export const SIZES = {
  tiny: 'tiny',
  small: 'small',
  medium: 'medium',
} as const;

export const SKINS = {
  standard: 'standard',
  error: 'error',
  success: 'success',
  premium: 'premium',
  disabled: 'disabled',
  primary: 'primary',
} as const;

export const WEIGHTS = {
  thin: 'thin',
  normal: 'normal',
  bold: 'bold',
} as const;
